import type { CSSProperties } from 'react';

export function sanitizeCSSVariables(styles: CSSProperties): CSSProperties | undefined {
  return Object.entries(styles).reduce((accum, [key, value]) => {
    if (value !== null) {
      accum[key as keyof CSSProperties] = value;
    }

    return accum;
  }, {} as CSSProperties);
}

export function getCSSVariableValue(name: string, root = document.querySelector(':root') || document.documentElement): string {
  return getComputedStyle(root).getPropertyValue(name);
}
